import axios from 'axios'
import { handleApiError } from '@/utils/apiHelpers'

export default {
    getLocalizationScreenGroups({ commit }, payload = {
        paginate: '',
        query: ''}) {
        const paginate = payload.paginate,
            query = payload.query

        commit('GET_LOCALIZATION_SCREEN_GROUPS_REQUEST')

        return axios
            .get(`/outdoors/outdoor-localization-screen-groups${paginate}${query}`)
            .then(response => {
                commit('GET_LOCALIZATION_SCREEN_GROUPS_SUCCESS', response.data.results)

                return Promise.resolve(response)
            })
            .catch(error => {
                commit('GET_LOCALIZATION_SCREEN_GROUPS_FAILURE')
                handleApiError(error, 'Pobranie grup ekranów nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getLocalizationScreenGroup(context, id) {
        return axios
            .get(`/outdoors/outdoor-localization-screen-groups/${id}`)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, `Pobranie danych dla grupy ekranu ${id} nie powiodło się.`)

                return Promise.reject(error)
            })
    },
    createLocalizationScreenGroup({ commit }, payload) {
        return axios
            .post('/outdoors/outdoor-localization-screen-groups', payload)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Grupa ekranu została dodana.'
                }, {root: true})

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Dodanie grupy ekranu nie powiodło się.')

                return Promise.reject(error)
            })
    },
    updateLocalizationScreenGroup({ commit }, payload) {
        return axios
            .put(`/outdoors/outdoor-localization-screen-groups/${payload.id}`, payload)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Grupa ekranu została zedytowana.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Zapis nie powiódł się.')

                return Promise.reject(error)
            })
    },
    deleteLocalizationScreenGroup({ commit }, id) {
        return axios
            .delete(`/outdoors/outdoor-localization-screen-groups/${id}`)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Grupa ekranu została usunięta.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Usunięcie grupy ekranu nie powiodło się.')

                return Promise.reject(error)
            })
    },
}